import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { RegulatoryStatus } from "../..";

@Injectable()
export class RegulatoryStatusService extends BaseDataService<RegulatoryStatus> {
  constructor(http: HttpService) {
    super(http, "regulatorystatus");
  }

  createInstance(options: any): RegulatoryStatus {
    return new RegulatoryStatus(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
